<form
  class="needs-validation"
  id="general-form"
  [formGroup]="buildingDetailsFormGroup"
  (ngSubmit)="save()"
>
  <div class="single-card">
    <div class="row">
      <div class="col-md-12">
        <app-switch-input
          [label]="'طلب تجريبي'"
          [labelEn]="'is_test'"
          [value]="is_test"
          [index]="1"
          (valueChanged)="codeValueChanged($event)"
        >
        </app-switch-input>
      </div>
    </div>
  </div>
  <div class="main-card">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"> اسم العميل <span class="red">*</span></label>
          <a class="add-item" (click)="addClient()"
            ><img alt="" src="/assets/images/svg/add-icon-blue.svg" /> إضافة
            عميل
          </a>
          <ng-select
            bindLabel="name"
            (scrollToEnd)="onScrollPagination()"
            #client
            placeholder="يرجى تحديد العميل"
            appendTo="body"
            formControlName="order_client"
            [searchable]="true"
            (search)="searchtext()"
            (clear)="resetSearch()"
            (open)="resetSearch()"
            [virtualScroll]="true"
            [clearable]="true"
          >
            @for (client of clients; track client) {
            <ng-option [value]="client.id">
              {{ client.full_name }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"> نوع الوحدة <span class="red">*</span></label>
          <ng-select bindLabel="name" class="single-select" #buildingUnit placeholder="يرجى تحديد نوع الوحدة" appendTo="body"
            (change)="buildingTypeChanged($event)" formControlName="building_type" [searchable]="true"
            [clearable]="true">
            @for (type of buildingTypes; track type) {
            <ng-option [value]="type.id">
              {{ type.name }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>
      @if (buildingDetailsFormGroup.get('building_type').value ==
      buildingType.Other) {
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">أدخل نوع العقار</label>
          <input
            type="text"
            formControlName="custom_property_type"
            class="form-control"
            placeholder="أدخل نوع العقار"
          />
        </div>
      </div>
      }
      <div class="col-6">
        <div class="form-group">
          <label for="" class="form-label">عدد الأدوار</label>
          <input
            type="number"
            formControlName="floors_number"
            class="form-control"
            placeholder=" يرجى تحديد عدد الأدوار "
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"> المساحة   </label>
          <span class="static-code">م<sup>2</sup></span>
          <input
            type="number"
            formControlName="initial_space"
            class="form-control"
            placeholder=" يرجى تحديد مساحة العقار "
          />
          <img
            class="form-control-feedback"
            alt=""
            src="assets/images/svg/error-icon1.svg"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">هدف العميل من الطلب <span class="red">*</span></label>
          <ng-select bindLabel="name" class="single-select"
            #selectStatus
            placeholder="هدف العميل من الطلب"
            appendTo="body"
            formControlName="client_goal"
            [searchable]="true"
            [clearable]="true">
            @for (item of clientGoals; track item) {
              <ng-option [value]="item.id" >
                {{item.name}}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>
      <div class="col-6">
        <select-paginated
          [placeholder]="'يرجى كتابة اسم المشروع'"
          [label]="'اسم المشروع'"
          [items]="projectsList"
          [selectedContract]="selectedContract"
          [pageCount]="pageCount"
          (params)="getProjectsByParams($event)"
          (itemData)="setProjectData($event)"
          [readonly]="projectId"
        >
        </select-paginated>
      </div>
      @if (buildingDetailsFormGroup.get('contract').value) {
      <div class="col-md-6">
        <select-paginated
          [placeholder]="'ربط مع الطلب'"
          [label]="'ربط مع الطلب'"
          [bindLabel]="'reference_number'"
          [items]="referenceNumberList"
          [selectedContract]="selectedRefrenceNumber"
          (itemData)="setRefrenceData($event)"
          (params)="getRefrenceNumberByParams($event)"
          [pageCount]="refrencePageCount"
        >
        </select-paginated>
      </div>
     }
      <div class="col-6">
        <div class="form-group">
          <label for="" class="form-label"> نوع الطلب <span class="red">*</span></label>
          <ng-select bindLabel="name" class="single-select" #orderTypeField placeholder="يرجى تحديد نوع الطلب"
            appendTo="body" [readonly]="isEditMode" formControlName="order_type" [searchable]="true"
            [clearable]="true" (change)="changeOrderType($event)" >
            @for (type of orderTypes; track type) {
            <ng-option [value]="type.pk">
              {{ type.name }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>
      @if (
          buildingDetailsFormGroup.get('order_type').value ==
          orderType.DynamicServices
        ) {
        <div class="col-6">
          <select-paginated
            [placeholder]="'يرجى احتيار الخدمة'"
            [label]="'الخدمات'"
            [required]="true"
            [items]="servicesList"
            [selectedContract]="selectedService"
            [pageCount]="servicesPageCount"
            (params)="getDynamicServices($event)"
            (itemData)="setServiceData($event)"
          >
          </select-paginated>
        </div>
      }

      <div class="col-6">
        <div class="checkBox-wrapper">
          <label class="checkbox-container">
            <input
              type="checkbox"
              formControlName="has_attached_building"
            />
            <span class="checkmark"> </span>
          </label>
          <span class="checkbox-label">يوجد ملحق بالعقار</span>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label for="" class="form-label">
            المطور العقارى
          </label>
          <ng-select
            bindLabel="name_arabic"
            bindValue="pk"
            placeholder="يرجى اختيار المطور العقاري"
            appendTo="body"
            formControlName="linked_real_estate_project_developer"
            [searchable]="true"
            [clearable]="true"
            [virtualScroll]="true"
            (scrollToEnd)="onCompanyScroll()"
            (search)="onCompanySearch($event)"
            (change)="companyChanged($event)"
          >
            @for (company of companies; track company.pk) {
              <ng-option [value]="company.pk">
                {{ company.name_arabic }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label for="" class="form-label">
            المشروع العقارى
          </label>
          <ng-select
            bindLabel="name_ar"
            bindValue="id"
            placeholder="يرجى اختيار المشروع العقاري"
            appendTo="body"
            formControlName="linked_real_estate_project"
            [searchable]="true"
            [clearable]="true"
            [virtualScroll]="true"
          >
            @for (project of reProjects; track project.id) {
              <ng-option [value]="project.id">
                {{ project.name_ar }}
              </ng-option>
            }
          </ng-select>
        </div>
      </div>

      @if (buildingDetailsFormGroup.get('is_test').value) {
        <div class="col-6">
          <div class="checkBox-wrapper">
            <label class="checkbox-container">
              <input
                type="checkbox"
                formControlName="allow_order_notifications"
              />
              <span class="checkmark"> </span>
            </label>
            <span class="checkbox-label"> تفعيل التنبيهات للطلب التجريبي</span>
          </div>
        </div>
      }

      @if (showAlertMsg) {
      <div class="alert-box">
        <img
          alt=""
          src="assets/images/svg/error-icon.svg"
          class="close-alert"
          alt=""
          (click)="hideErrorMsg()"
        />
        <p class="alert-msg">{{ alertMessage }}</p>
      </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 confirm-next-step">
      <button class="btn btn-green">التالي</button>
    </div>
  </div>
</form>
